import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { provideNativeDateAdapter } from '@angular/material/core';

import { CoreModule } from '@core/core.module';
import { CoreSidebarModule } from '@core/components';
import { CoreCommonModule } from '@core/common.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { JwtInterceptor, ErrorInterceptor } from 'app/authentication/helpers';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateModule } from '@ngx-translate/core';
import { BlockUIModule } from 'ng-block-ui';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { FooterComponent } from './components/common/footer/footer.component';
import { HeaderComponent } from './components/common/header/header.component';
import { LandingRedirectComponent } from './components/landing-redirect/landing-redirect.component';

@NgModule({
  declarations: [AppComponent, HeaderComponent, FooterComponent, LandingRedirectComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgIdleKeepaliveModule.forRoot(),
    TranslateModule.forRoot(),
    BlockUIModule.forRoot({
      message: 'Loading...',
    }),
    MatGoogleMapsAutocompleteModule.forRoot('AIzaSyAjg5UjfCQOG_pZkGMO6IYv2AW5Za51UCU'),
    CoreModule,
    CoreCommonModule,
    CoreSidebarModule,
    AppRoutingModule,
    MatMenuModule,
    MatButtonModule,
  ],
  providers: [
    DatePipe,
    // Global Material date adapter. Required by every MatDatepicker; previously supplied by the
    // moment adapter, which was removed. Native adapter keeps it dependency-free (date-fns is used elsewhere).
    provideNativeDateAdapter(),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
